const {CryptoJS} = require('../../kabala3rd/crypto');
const $khttpsignature = require('./khttp-signature');

// const $khttpsignature = require('./khttp-signature.js');
//JSON解析函数（针对服务器端的返回值进行解析）
//JSON.parse 在进行json转换时只能支持最大 2^53 的数值精度，超出则会丢失精度，因此我们需要进行特殊处理(apinode.cnum/wnum写操作编号，都会超出该数值范围)
function _parseJsonDatas(baseStr) {
    if (!baseStr || typeof baseStr != 'string') return;
    try {
		var result = JSON.parse(baseStr);
		result.toString = function(){
			return result.data;
		}
		return result;
    } catch (err){
        return null;
    }
	/*
    var needReplaceStrs = [];
    _loopFindArrOrObj(jsonData,needReplaceStrs);
	console.log("needReplaceStrs",needReplaceStrs);
    needReplaceStrs.forEach(function (replaceInfo) {
        var matchArr = baseStr.match(eval('/"'+ replaceInfo.key + '":[0-9]{15,}/'));
        if (matchArr) {
            var str = matchArr[0];
            var replaceStr = str.replace('"' + replaceInfo.key + '":','"' + replaceInfo.key + '":"');
            replaceStr += '"';
            baseStr = baseStr.replace(str,replaceStr);
        }
    });
    var returnJson = null;
    try {
        returnJson = JSON.parse(baseStr);
    }catch (err){
        return null;
    }
    return returnJson;
	*/
}
//遍历对象类型的
function _getNeedRpStrByObj(obj,needReplaceStrs) {
    for (var key in obj) {
        var value = obj[key];
        if (typeof value == 'number' && value > 9007199254740992){
            needReplaceStrs.push({key:key});
        }
        _loopFindArrOrObj(value,needReplaceStrs);
    }
}
//遍历数组类型的
function _getNeedRpStrByArr(arr,needReplaceStrs) {
    for(var i=0; i<arr.length; i++){
        var value = arr[i];
        _loopFindArrOrObj(value,needReplaceStrs);
    }
}
//递归遍历
function _loopFindArrOrObj(value,needRpStrArr) {
    var valueTypeof = Object.prototype.toString.call(value);
    if (valueTypeof == '[object Object]') {
        needRpStrArr.concat(_getNeedRpStrByObj(value,needRpStrArr));
    }
    if (valueTypeof == '[object Array]') {
        needRpStrArr.concat(_getNeedRpStrByArr(value,needRpStrArr));
    }
}

function json2query(obj, prefix) {
  prefix = prefix || '';
  var pairs = [];
  var has = Object.prototype.hasOwnProperty;
  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';
  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(key +'='+ encodeURIComponent(obj[key]));
    }
  }
  return pairs.length ? prefix + pairs.join('&') : '';
}
const $khttp = {
	//获取或设置会话对象
	//session 对象格式为
	//		{
	//			userid:"",
	//			tenantid:"",
	//			accesskey: {accesskeyid, accesskeysecret, accesskeytime(时间格式为1970年至今的秒数), accessdomain},
	//			apps: 	[ appid, appname, appimg, appindex],
	//			spaces: [ spacetype, spaceid, spacename, spaceapi, spaceroot ]
	//		}
	session:function(ses){
		if( typeof ses =='undefined' ){

			//get...
			var mysession = window.localStorage.getItem("kabala.session");
			if(typeof mysession !='undefined' && mysession!=null){
				try{
					var base64Array = CryptoJS.enc.Base64.parse(mysession);
					var base64Session = base64Array.toString(CryptoJS.enc.Utf8);
					var session = JSON.parse(base64Session);
					return session;
				}catch(e){
					try{
						var session = JSON.parse(mysession);
						return session;
					}catch(e1){
						return {};
					}
				}
			}else{
				return {};
			}
		}else{
			//set...
			window.localStorage.removeItem("kabala.session");
			//2.写入本地缓存 kabala.session
			if(ses!=null && ses.accesskey!=null){
				if(!ses.accesskey.localtime){
					ses.accesskey.localtime = parseInt(new Date().getTime()/1000);
				}
				var wordArray = CryptoJS.enc.Utf8.parse(JSON.stringify(ses));
				var base64 = CryptoJS.enc.Base64.stringify(wordArray);
				window.localStorage.setItem("kabala.session", base64);
			}
		}
	},
	//为url追加签名
	signUrl:function(verb, url){
		var session = $khttp.session();
		var ak = (session==null || session.accesskey==null || (typeof session.accesskey == 'undefined')) ? null : session.accesskey;
		if(ak==null)
			return url;
		var signparams = $khttpsignature.buildUrlParams(ak, verb, url);
		var signurl = url;
		for(var key in signparams){
			var val = signparams[key];

			if(signurl.indexOf('?')<0)
				signurl += '?';
			else
				signurl += '&';
			signurl += (key+"="+val);
		}
		return signurl;
	},
	fetchBase:function(method, uri, datas,async){
		if(datas!=undefined){
			for(var key in datas){
				if(datas[key]==undefined){
					delete datas[key];
				}
			}
		}
		var headers = {};
		var session = $khttp.session();
		var ak = (session==null || session.accesskey==null || (typeof session.accesskey == 'undefined')) ? null : session.accesskey;
		if(ak!=null){
			headers = $khttpsignature.buildHeader(ak, method.toUpperCase(), uri, datas);
		}

		var url = uri;
		var payload = null;
		if(datas!=null){
			var query = "";
			for(var key in datas){
				if(query.length>0)
					query += "&";
				query += key+"="+encodeURIComponent(datas[key]);
			}

			if(method.toUpperCase()=='GET'){
				url += "?"+query;
			}else if(method.toUpperCase()=='POST'){
				payload = query;
			}
		}
		var xhr = null;
		if (window.ActiveXObject) {
			xhr = new ActiveXObject("Microsoft.XMLHTTP");
		} else if (window.XMLHttpRequest) {
			xhr = new XMLHttpRequest();
		}

		xhr.open(method, url, async);
		xhr.setRequestHeader('If-Modified-Since', '0');
		if(method.toUpperCase()=="POST"){
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
		}
		if(headers!=null){
			for (var key in headers){
				xhr.setRequestHeader(key, headers[key]);
			}
		}
		xhr.withCredentials=false;
		return {"xhr":xhr,"payload":payload};
	},
	fetchSync:function(method, uri, datas){
		var ajax = $khttp.fetchBase(method, uri, datas,false);
		try{
			ajax.xhr.send(ajax.payload);
			var xresp = ajax.xhr.response;
			if(ajax.xhr.status>=200 && ajax.xhr.status<300){
				return _parseJsonDatas( xresp );
			}else{
				return $khttp.formatHttpStatus(ajax.xhr.status);
			}
		}catch(e){
			var resp = new Object();
			resp.code = 1;
			resp.data = "请求服务器失败";
			return resp;
		}
	},
	formatHttpStatus:function(statuscode){
		var errtips = "";
		if(statuscode==401){
			errtips = "用户没有被授权,请重新登录后再尝试.";
		}else if(statuscode==404){
			errtips = "请求资源不存在.";
		}else if(statuscode==403){
			errtips = "服务器拒绝请求.";
		}else if(statuscode==500){
			errtips = "服务器请求异常,请稍后再试.";

		}else if(statuscode<400 && statuscode>=300 ){
			errtips = "["+statuscode+"]请求已被重定向.";

		}else if(statuscode<500 && statuscode>=400 ){
			errtips = "["+statuscode+"]无效的请求.";
		}else if(statuscode>500){
			errtips = "["+statuscode+"]服务器请求异常.请稍后再试.";
		}
		if($khttp.RequestErrorHander){
			// 默认没有动作, 可以在顶层页面window注册操作
			$khttp.RequestErrorHander( statuscode );
		}
		var resp = new Object();
		resp.code = 1;
		resp.data = errtips;
		// 实现toString, 避免早期代码错误提示object
		resp.toString = function( ){
			return resp.data;
		}
		return resp;
	},
	RequestErrorHander: function(code){
		try {
			if( (top||window).postMessage ){
				(top||window).postMessage({
					type: 'KHTTP-REQUESTERROR',
					data: code,
				}, '*');
			}
		} catch (e) {
			console.log(e)
		}
	},
	fetch:function(uri, datas,method){
        return new Promise(function(resolve, reject){
            var ajax = $khttp.fetchBase(method, uri, datas,true);
			ajax.xhr.onload=function(){
				var xresp = ajax.xhr.response;
				if(ajax.xhr.status>=200 && ajax.xhr.status<300){
					resolve(xresp);
				}else{
					reject($khttp.formatHttpStatus(ajax.xhr.status));
				}
            }
			try{
				ajax.xhr.send(ajax.payload);
			}catch(e){
				var resp = new Object();
				resp.code = 1;
				resp.data = "请求服务器失败";
				reject(resp);
			}
        });
    },
	getSync:function(uri, datas){
		var response = $khttp.fetchSync('GET', uri, datas,false);
		if(response.code == 0){
			return response.data;
		}else{
			throw response.data;
		}

	},
	postSync:function(uri, datas){
		var response = $khttp.fetchSync('POST', uri, datas,false);
		if(response.code == 0){
			return response.data;
		}else{
			throw response.data;
		}
	},
	get:function(uri, datas){
		if(datas==null || typeof datas=='undefined'){
		}else{
			uri = uri + "?" + json2query(datas);
		}
		return new Promise(function(resolve, reject){
			$khttp.fetch( uri, null, "get").then( function(res) {
				let Res = _parseJsonDatas( res );
				if (Res.code === 0) {
					resolve(Res.data);
				} else {
					reject(Res)
				}
			}).catch(function(err){
				reject(err);
			})
		})
	},
	post:function (uri, datas){
		return new Promise( function(resolve, reject) {
			$khttp.fetch( uri, datas, "post").then(function(res){
				let Res = _parseJsonDatas( res );
				if (Res.code === 0) {
					resolve(Res.data)
				} else {
					reject(Res)
				}
			}).catch( function(err){
				reject(err)
			})
		})
	},
	formatResponse:function(resp){
		return _parseJsonDatas( resp );
	}
}
module.exports = $khttp;
